import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { updateActualElement, setActiveElement } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import UploadImage from '@/components/UploadImage'
import Border from '@/components/editors/Border'
import BoxShadow from '@/components/editors/BoxShadow'
import BorderRadius from '@/components/editors/BorderRadius'

class IframeContent extends Component {
  state = {
    type: 'embed'
  }

  save = element => {
    const { id, id_page: pageID } = element
    const { updateActualElement, user: { accessToken } } = this.props

    updateActualElement({
      id,
      pageID,
      element,
      accessToken
    })
  }

  handleStyles = style => {
    const { element } = this.props

    element.content.styles = {
      ...element.content.styles,
      ...style
    }
    this.save(element)
  }

  handleContent = content => {
    const { element } = this.props

    element.content.content = {
      ...element.content.content,
      ...content
    }

    this.save(element)
  }


  handleEmbedURL = value => {
    this.handleContent({
      embedURL: value,
      embedDocument: ''
    })
  }

  handleEmbedDocument = value => {
    this.handleContent({
      embedURL: '',
      embedDocument: value
    })
  }

  handleImageSended = src => this.handleContent({ src })

  handleBorder = ({ type, size, color }) => this.handleStyles({
    borderStyle: type,
    borderWidth: `${size}px`,
    borderColor: color
  })

  handleShadow = shadow => this.handleStyles({
    boxShadow: `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`
  })

  render() {
    const { translation, element } = this.props

    const {
      borderWidth,
      borderStyle,
      borderColor,
      boxShadow,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
    } = element.content.styles

    const { embedURL, embedDocument } = element.content.content

    return (
      <div className={'ba-pd-r-1'}>
        <hr className={'ba-hr'} />
        <p className={'ba-font'}>{translation('general-embed-url')}</p>
        <input
          className='ba-input ba-w-100'
          placeholder={translation('general-embed-url')}
          value={embedURL}
          onChange={({ target }) => this.handleEmbedURL(target.value)}
        />
        <textarea
          className={'ba-input ba-w-100 ba-mg-t-1 ' + styles['text-area']} rows={'15'}
          placeholder={translation('general-embed-document')}
          value={embedDocument}
          onChange={({ target }) => this.handleEmbedDocument(target.value)}
        />

        <hr className={'ba-hr'} />

        <p className='ba-font'>{translation('image-component')}</p>
        <UploadImage
          text={translation('image-select')}
          onImageSended={this.handleImageSended}
        />
        <small className={''}>{translation('iframe-send-image-warning')}</small>

        <hr className={'ba-hr'} />

        <p className='ba-font'>{translation('general-border')}</p>
        <Border
          type={borderStyle}
          size={borderWidth}
          color={borderColor}
          onChange={this.handleBorder}
        />

        <hr className={'ba-hr'} />

        <p className='ba-font'>{translation('general-shadow')}</p>
        <BoxShadow
          shadow={boxShadow}
          onChange={this.handleShadow}
        />

        <hr className={'ba-hr'} />

        <p className='ba-font'>{translation('general-border-radius')}</p>
        <BorderRadius
          topLeft={borderTopLeftRadius}
          topRight={borderTopRightRadius}
          bottomLeft={borderBottomLeftRadius}
          bottomRight={borderBottomRightRadius}
          onChange={this.handleStyles}
        />
      </div>
    )
  }
}

const mapStateProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateProps,
  {
    updateActualElement,
    setActiveElement
  }
)(IframeContent)


// WEBPACK FOOTER //
// ./src/pages/Editor/components/ContentEditor/editors/IframeContent/index.js